"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var cellStates = _interopRequireWildcard(require("../cellStates"));

var shapes = _interopRequireWildcard(require("../shapes"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: #d3d9df;\n  box-shadow: inset -2px 0 #75b2d8;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-top: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 30px;\n  justify-content: center;\n  margin: 0 2px;\n  padding: 0 11px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: stretch;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var cellStyle = (0, _emotion.css)(_templateObject());
var innerStyle = (0, _emotion.css)(_templateObject2(), colors.white);
var selectedStyle = (0, _emotion.css)(_templateObject3());

function isLeftOrRight(buttons) {
  /* eslint-disable-next-line no-bitwise */
  return buttons & 0x01 || buttons & 0x02;
}

var RowHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RowHeader, _PureComponent);

  function RowHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RowHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RowHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseDown", function (event) {
      var _this$props = _this.props,
          rowIndex = _this$props.rowIndex,
          onDragStart = _this$props.onDragStart;

      if (isLeftOrRight(event.buttons)) {
        onDragStart(rowIndex);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseOver", function (event) {
      var _this$props2 = _this.props,
          rowIndex = _this$props2.rowIndex,
          onDragMove = _this$props2.onDragMove;

      if (isLeftOrRight(event.buttons)) {
        onDragMove(rowIndex);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(RowHeader, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          mode = _this$props3.mode,
          rowIndex = _this$props3.rowIndex,
          style = _this$props3.style;
      var isSelected = mode !== cellStates.inactive;
      /* eslint-disable jsx-a11y/no-static-element-interactions */

      /* eslint-disable jsx-a11y/mouse-events-have-key-events */

      return _react.default.createElement("div", {
        className: (0, _emotion.cx)(cellStyle, (0, _defineProperty2.default)({}, selectedStyle, isSelected)),
        style: style,
        onMouseDown: this.onMouseDown,
        onMouseOver: this.onMouseOver
      }, _react.default.createElement("div", {
        className: innerStyle
      }, rowIndex + 1));
      /* eslint-enable jsx-a11y/no-static-element-interactions */

      /* eslint-enable jsx-a11y/mouse-events-have-key-events */
    }
  }]);
  return RowHeader;
}(_react.PureComponent);

exports.default = RowHeader;
(0, _defineProperty2.default)(RowHeader, "propTypes", {
  mode: shapes.cellMode.isRequired,
  rowIndex: _propTypes.default.number.isRequired,
  style: _propTypes.default.objectOf(_propTypes.default.any),
  onDragMove: _propTypes.default.func.isRequired,
  onDragStart: _propTypes.default.func.isRequired
});